<template>
  <div class="login-form">
    <el-alert
      title="Error logging in"
      type="error"
      class="err">
    </el-alert>
    <el-form :model="credentials" :rules="validators" ref="credentials" class="login-form">
      <el-form-item  prop="username">
        <el-input type="text" v-model="credentials.username" class="login-input" placeholder="Email or Username"></el-input>
      </el-form-item>
      <el-form-item  prop="password">
        <el-input type="password" v-model="credentials.password" auto-complete="off" class="login-input" @keyup.enter.native="submit('credentials')" placeholder="Password"></el-input>
      </el-form-item>
    
      <div @click="forgotPassword" class="fpLink">Forgotten Password?</div>

      <div class="login-btns">
        <el-button type="add" @click="submit('credentials')">Login</el-button>
        <!-- <el-button type="cancel" @click="reset('credentials')">Reset</el-button> -->
      </div>
      
    </el-form>
  </div>
</template>

<script>
import auth from '../auth/index'
export default {
  name: 'login-form',
  props: ['redirect'],
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      }
      if (value.length < 6) {
          callback(new Error('Password must be more than 6 characters'));
      }
      callback();
    };
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter a username'));
      }
      callback();
    };
    return {
      msg: 'Log in',
      credentials: {
        username: '',
        password: ''
      },
      validators: {
         password: [
            { validator: validatePass, trigger: 'blur' }
          ],
          username: [
            { validator: validateUser, trigger: 'blur' }
          ]
      },
      error: '',
    }
  },
  methods: {
    submit(formName) {
      var credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      }
      auth.login(this, credentials, this.redirect || this.$route.path);
    },
    reset(formName){
      document.querySelector('.login-form .err').style.display = "none";
      this.credentials.username = '';
      this.credentials.password = '';
      this.$refs[formName].resetFields();
    },
    forgotPassword(){
      this.$router.push({path: '/forgot-password'});
    }
  }
}
</script>

<style>
  /* .login-form {
    padding: 2em;
    margin: 0 auto;
    margin-top: 15pt;
  } */
  
  .login-form  {
    background-color: white;
    display: inline-block;
    width: 100%;
  }
  
  .login-form  .err{
    margin-top: 2em !important;
    width: 100%;
    margin: 4px auto;
    display: none;
  }
  
  .login-btns {
    /* display:inline-block; */
    float: left;
    margin-top: 15pt;
    padding-bottom: 30pt;
  }

  .fpLink {
    text-align: left;
    color: #6CA5E7;
    text-decoration: underline;
    cursor: pointer;
  }
  
</style>



// WEBPACK FOOTER //
// LoginForm.vue?00ce3c61